import React from 'react'
import { get } from 'lodash'
import { Box, Container } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { ErrorBoundary } from '@scoir/error-reporter'

import features from 'common/college-features'
import useCollegeFeatures from 'common/use-college-features'
import systemPermissions from 'common/system-permissions'
import usePermissions from 'common/use-permissions'
import useIsShadow from 'common/use-is-shadow'
import useTitle from 'common/use-title'

import CollegeMetrics from './CollegeMetrics'
import MetricsTeaser from './components/MetricsTeaser'
import ErrorMessage from './components/ErrorMessage'

const useStyles = makeStyles((theme) => ({
  componentWrapper: {
    backgroundColor: get(theme, 'palette.pageBackground.main'),
    paddingBottom: theme.spacing(10),
  },
}))

export const Dashboard = () => {
  useTitle('Scoir - Dashboard')
  const supportsAnalytics = useCollegeFeatures(features.SUPPORTS_STUDENT_ANALYTICS)
  const canUserSeeMetrics = usePermissions(systemPermissions.VIEW_COLLEGE_ENGAGEMENT_METRICS)
  const isShadowUser = useIsShadow()
  const showCollegeMetrics = (supportsAnalytics && canUserSeeMetrics) || isShadowUser
  const classes = useStyles()
  return (
    <Box
      className={classes.componentWrapper}
      px={[0, 3, 5]}
      py={5}
    >
      <Container maxWidth="lg">
        <ErrorBoundary errorComponent={ErrorMessage}>
          {showCollegeMetrics ? <CollegeMetrics /> : <MetricsTeaser />}
        </ErrorBoundary>
      </Container>
    </Box>
  )
}

export default Dashboard
